import { render, staticRenderFns } from "./RedirectDomainsPage.vue?vue&type=template&id=626265ee&scoped=true&"
import script from "./RedirectDomainsPage.vue?vue&type=script&lang=js&"
export * from "./RedirectDomainsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626265ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('626265ee')) {
      api.createRecord('626265ee', component.options)
    } else {
      api.reload('626265ee', component.options)
    }
    module.hot.accept("./RedirectDomainsPage.vue?vue&type=template&id=626265ee&scoped=true&", function () {
      api.rerender('626265ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/RedirectDomainsPage.vue"
export default component.exports